import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable, Subscription, map } from 'rxjs';

import { Breadcrumb } from 'src/app/core/models/breadcrumb.model';
import { ProjectDataActions } from '../../store/project-data/project-data.actions';
import { selectLatestActionCausedError, selectLatestCreatedId } from '../../store/project-data/project-data.selectors';

@Component({
  selector: 'app-create-project-view',
  templateUrl: './create-project-view.component.html',
  styleUrls: ['./create-project-view.component.scss'],
  standalone: false
})
export class CreateProjectViewComponent implements OnInit, OnDestroy {
  breadcrumbs: Breadcrumb[] = [];
  currentBreadcrumb: Breadcrumb = { url: '', text: '', translatable: false, isCurrent: true };
  latestCreatedId$: Observable<string | null>;
  actionCausedError$: Observable<boolean>;

  latestCreatedIdSubscription: Subscription;
  actionCausedErrorSubscription: Subscription;

  constructor(private store: Store, private router: Router) {
    this.latestCreatedId$ = this.store.select(selectLatestCreatedId);
    this.actionCausedError$ = this.store.select(selectLatestActionCausedError);
    this.currentBreadcrumb.url = '/projects/new';
    this.currentBreadcrumb.text = 'UI.Common.Breadcrumb.UnnamedProject';
    this.currentBreadcrumb.translatable = true;
    this.breadcrumbs = [
      { url: '/projects', text: 'UI.Common.Breadcrumb.Projects', translatable: true, isCurrent: false },
      this.currentBreadcrumb
    ];
  }

  ngOnInit() {
    this.store.dispatch(ProjectDataActions.create_project_start());
    this.watchProjectEntityCreated();
  }

  ngOnDestroy(): void {
    this.latestCreatedIdSubscription?.unsubscribe();
    this.actionCausedErrorSubscription?.unsubscribe();
  }

  watchProjectEntityCreated() {
    // We want to use replaceUrl to have proper browser history -> browser back button should not lead back to "new project" -page
    const navigateOptions: NavigationExtras = {
      replaceUrl: true
    };

    this.latestCreatedIdSubscription = this.latestCreatedId$
      .pipe(
        map(id => {
          if (id !== null) {
            this.store.dispatch(ProjectDataActions.reset_latest_created_id());
            this.router.navigate(['/projects', id], navigateOptions);
          }
        })
      )
      .subscribe();

    this.actionCausedErrorSubscription = this.actionCausedError$.subscribe(causedError => {
      if (causedError) {
        this.router.navigate(['/projects'], navigateOptions);
      }
    });
  }
}
